module.exports = __webpack_public_path__ + "img/product-info.c4db0d36.png";